module.exports = __webpack_public_path__ + "models/scene3.437936d.txt";